import { BaseRequest } from "../base-request";

export class PairingRequest extends BaseRequest {
  constructor(options: {
    Username: string;
    Password: string;
    PairCode: string;
  }) {
    super();
    this.Username = options.Username;
    this.Password = options.Password;
    this.PairCode = options.PairCode;
  }

  // Linkly Cloud username
  public Username: string;

  // Linkly Cloud password
  public Password: string;

  // The pair-code as displayed on the PIN pad
  public PairCode: string;
}
